import { GET_LIST_GRUP_KALENDER, CREATE_GRUP_KALENDER, GET_LIST_ACARA, GET_PIC_ACARA, CREATE_ACARA, GET_ID_GRUP, GET_DETAIL_ACARA, GET_DETAIL_GRUP, DELETE_ID_GRUP, DELETE_ACARA_KALENDER, DELETE_PIC, GET_LIST_ACARA_EVENT, GET_STATE, GET_LIST_SUBAGENDA } from "shared/constants/ActionTypes";

const listSubAgenda = {
    count: 0,
    next: null,
    previous: null,
    results: []
}

const initialState = {
    pic: null,
    acara: null, 
    state: null,
    idGrup: null,
    detail: null,
    detailGrup: null,
    grupKalender: null,
    listSubAgenda: listSubAgenda
}

const agendaBersamaReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_GRUP_KALENDER:
            return {
                ...state,
                grupKalender: action.payload
            }
        case GET_LIST_ACARA:
            return {
                ...state,
                acara: action.payload
            }
        case GET_LIST_ACARA_EVENT:
            return {
                ...state,
                acara: action.payload
            }
        case GET_PIC_ACARA:
            return {
                ...state,
                pic: action.payload
            }
        case GET_ID_GRUP:
            return {
                ...state,
                idGrup: action.payload
            }
        case GET_STATE:
            return {
                ...state,
                state: action.payload
            }
        case CREATE_GRUP_KALENDER:
            return {
                ...state
            }
        case CREATE_ACARA:
            return {
                ...state
            }
        case GET_DETAIL_ACARA:
            return {
                ...state,
                detail: action.payload
            }
        case GET_LIST_SUBAGENDA:
            return {
                ...state,
                listSubAgenda: action.payload
            }
        case GET_DETAIL_GRUP:
            return {
                ...state,
                detailGrup: action.payload
            }
        case DELETE_ID_GRUP:
            return {
                ...state,
                idGrup: null
            }
        case DELETE_ACARA_KALENDER:
            return {
                ...state,
                acara: null
            }
        case DELETE_PIC:
            return {
                ...state,
                pic: null
            }
        default:
            return state;
    }
}

export default agendaBersamaReducer